@if (showFooter) {
  <footer>
    <a href="https://www.papinsport.com/" target="_blank">Papin Sport GmbH</a>
  </footer>
}
